"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DRIPPING_CONTEXT_NAME = exports.TWO_MINUTES_IN_MILLISECONDS = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const translationContext_1 = require("configs/translationContext");
const clubWebSocket_1 = require("helpers/clubWebSocket");
const documentUtil_1 = __importDefault(require("helpers/documentUtil"));
const ui_1 = require("modules/ui");
const bulkDrippingFeedback_module_scss_1 = __importDefault(require("./bulkDrippingFeedback.module.scss"));
exports.TWO_MINUTES_IN_MILLISECONDS = 120000;
exports.DRIPPING_CONTEXT_NAME = 'DrippingInBulk';
const BULK_DRIPPING_FEEDBACK_PORTAL_ID = 'app-club-admin-feedback-container';
const bulkDrippingFeedbackModalRootElement = documentUtil_1.default.createElement(BULK_DRIPPING_FEEDBACK_PORTAL_ID);
const BulkDrippingFeedback = ({ title, contextId, onDone, onPartiallyDone, onError }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const [showStatus, setShowStatus] = (0, react_1.useState)(true);
    const [message, setMessage] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const handleMessage = (response) => {
            if (response.status === clubWebSocket_1.StatusResponse.Success) {
                setShowStatus(false);
                const { total = 0, completed = 0 } = response.message || {};
                onDone({ total, completed });
            }
            else if (response.status === clubWebSocket_1.StatusResponse.Error) {
                setShowStatus(false);
                const { total = 0, completed = 0 } = response.message || {};
                onPartiallyDone({ total, completed });
            }
            else if (response.status === clubWebSocket_1.StatusResponse.InProgress &&
                response.message) {
                setMessage((previousValue) => {
                    var _a;
                    return ({
                        ...response.message,
                        completed: Math.max(((_a = response.message) === null || _a === void 0 ? void 0 : _a.completed) || 0, (previousValue === null || previousValue === void 0 ? void 0 : previousValue.completed) || 0)
                    });
                });
            }
        };
        const handleError = () => {
            setShowStatus(false);
            onError();
            ui_1.UiService.setAlertError('error_try_again');
        };
        const socket = new clubWebSocket_1.ClubWebSocket({
            contextId,
            contextName: exports.DRIPPING_CONTEXT_NAME,
            onMessage: handleMessage,
            onError: handleError,
            messageTimeout: exports.TWO_MINUTES_IN_MILLISECONDS
        });
        return socket.close;
    }, [t, contextId, onDone, onPartiallyDone, onError]);
    if (!showStatus) {
        return null;
    }
    return (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsxs)("section", { className: bulkDrippingFeedback_module_scss_1.default.alert, role: "status", "aria-labelledby": "dripping-feedback", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'spinner-third'], className: "_text-5", spin: true }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { className: "_m-0", id: "dripping-feedback", children: title }), message && ((0, jsx_runtime_1.jsx)("small", { children: t('dripping_2.bulk_action.report.description', {
                            amountToPluralize: message.total,
                            data: {
                                value: message.completed,
                                total: message.total
                            }
                        }) }))] })] }), bulkDrippingFeedbackModalRootElement);
};
exports.default = react_1.default.memo(BulkDrippingFeedback, (prevProps, nextProps) => {
    return prevProps.contextId === nextProps.contextId;
});
